module.exports = __webpack_public_path__ + "media/images/emblems/Alpnach-coat_of_arms-b2509e4d7891597a2d53f4d3fb1bf85d.svg";